var _circle, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#D6A796"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#D6A796"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2499 10C7.21706 10.0001 7.18454 9.99362 7.1542 9.98105C7.12386 9.96849 7.09631 9.95005 7.07312 9.9268L5.32312 8.17695C5.2999 8.15374 5.28148 8.12618 5.26892 8.09585C5.25635 8.06552 5.24988 8.03301 5.24988 8.00018C5.24987 7.93387 5.27621 7.87028 5.32309 7.82339C5.36997 7.7765 5.43356 7.75016 5.49986 7.75015C5.56617 7.75014 5.62976 7.77648 5.67665 7.82336L7.2499 9.39649L10.5731 6.07336C10.62 6.02647 10.6836 6.00012 10.7499 6.00012C10.8162 6.00012 10.8798 6.02646 10.9267 6.07334C10.9736 6.12023 10.9999 6.18382 10.9999 6.25013C10.9999 6.31644 10.9736 6.38003 10.9267 6.42692L7.42668 9.9268C7.40349 9.95004 7.37593 9.96847 7.34559 9.98104C7.31526 9.9936 7.28274 10.0001 7.2499 10Z",
    fill: "#63382C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.da94355c78ae9239df0ac3dac8d349f3.svg";
export { ForwardRef as ReactComponent };